<template>
  <nav class="flex px-3" aria-label="Breadcrumb">
    <ol class="flex items-center space-x-4">
      <li>
        <div>
        <!--  <router-link to="/admin/home" class="ml-4 text-2xl font-medium text-gray-900"> Home </router-link> -->
        </div>
      </li>
      <li v-for="(page, index) in pages" :key="page.name">
        <div class="flex items-center">
          <!--  <font-awesome-icon class="reaction" size="sm" :icon="['fas', 'chevron-right']" /> -->
          <div v-if="index == pages.length - 1">
            <label
              :href="page.href"
              class="text-2xl font-medium text-green-800"
              :aria-current="page.current ? 'page' : undefined"
            >
              {{ page.name }}
            </label>
          </div>
          <div v-if="index != pages.length - 1">
            <router-link
              :to="page.href"
              class="text-2xl font-bold text-green-800 hover:text-green-900"
              :aria-current="page.current ? 'page' : undefined"
            >
              {{ page.name }}
            </router-link>
          </div>
        </div>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: ['pages'],
};
</script>
